var _path, _setting;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaiLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector1",
    width: 69,
    height: 83,
    viewBox: "0 0 69 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.5H20L25.5 82L32.5 34.5L34.5 49.5L36 37.5L38 47.5L40 1L44.5 34.5L51 51.5H69",
    stroke: "#00A651",
    strokeWidth: 4,
    strokeDasharray: "0,0,0,252.9732666015625"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 100,
    dur: "1.9411764705882355s",
    values: "0,0,0,252.9732666015625;            0,126.48663330078125,126.48663330078125,0;            252.9732666015625,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":17,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiLoader);
export default __webpack_public_path__ + "static/media/TaiLoader.2d612bec79c29d64fe409a0a025ef3d1.svg";
export { ForwardRef as ReactComponent };